/*!
 * Widgets
 *
 */

function urlSafeString(s) {
    s = s || '';
    s = s.replace(/[^a-z0-9-]/gi, '_').toLowerCase();
    s = s.replace(/[_]+/g, '_');

    return s;
};

function trackVirtualPageView(domain, subUrl, title) {

  // com.inmplc.tracking.trackVirtualPageView('virtual-pis/' + subUrl);
};

function urlSafeString(s) {
    s = s || '';
    s = s.replace(/[^a-z0-9-]/gi, '_').toLowerCase();
    s = s.replace(/[_]+/g, '_');

    return s;
};

$(document).ready(function(){
	"use strict";

    var urlSafeString = function (s) {
        return (s ? s.replace(/[^a-z0-9]/gi, '_').toLowerCase() : '_');
    };

    $('.elections-a').each(function() {
        var $root = $(this);
        // select links
        $root.find('[data-dropnav]').on('change', function(event) {
            window.location = $(this).val();
        });

        if ( $('.e16chosen-a select').length ) {
          $('.e16chosen-a select').change(function() {
            if ($(this).val() != "Select Constituency") {
              var label = 'DropDown[' + $('body').attr("data-article") + ']|||||Main Area|Constituency List - ' + this.value + '||';
              location.href=this.value;
            }
          });
        }

        // tabs
        $root.find('[data-tabs] a[href^="#"]').on('click', function(event) {
            event.preventDefault();
            var $clicked = $(this);
            $($clicked.attr('href')).addClass('is-active').siblings('.is-active[data-tab]').removeClass('is-active');
        });

        // counts

        $root.find('.results[data-multiple]').each(function(index, el) {
            var $results = $(this);
            var $data = $results.find('.data');
            var count = $data.size();
            var current = count;

            var show = function(next, select){
                $results.find('.switch a.is-off').removeClass('is-off');
                if(next == 1) $results.find('.switch li.prev a').addClass('is-off');
                if(next == count) $results.find('.switch li.next a').addClass('is-off');
                if(!select) $results.find('select').val(next);
                current = next;
                $data.removeClass('is-active').filter(':eq('+(next-1)+')').addClass('is-active');
            };

            $results.find('.switch a').on('click', function(event) {
                event.preventDefault();
                var $clicked = $(this);
                if(!$clicked.is('.is-off')){
                    if($clicked.parent('.next').length) {
                        var next = parseInt(current) + 1;
                    } else {
                        var next = parseInt(current) - 1;
                    }

                    show(next, false);
                    exit;
                }
            });

            $results.find('.switch select').on('change', function(event) {
                show($(this).val(), true);
            });
        });
    });

        // toggle teasers
	$('.e16teaser-a').click(function(event) {
            var data = 'close';
            var candidate = $(this).find('h3.hx').text().trim();
            if (!$(this).hasClass('is-active')) {
                var subUrl = urlSafeString($('body').attr("data-article")) + "/open-candidate-info/" + urlSafeString(candidate);
                // com.inmplc.tracking.trackVirtualPageView('virtual-pis/' + subUrl);

                data = 'open';
                $(this).addClass('is-active');
            } else {
                $(this).removeClass('is-active');
            }

            var label = 'ReadMore[' + $('body').attr("data-article") + ']|||||Main Area|Candidate List - ' + candidate + '||' + data;
        });

	$('<a href="#" class="toggler"></a>').on('click', function(event) {
            event.preventDefault();
	}).prependTo($('.e16teaser-a > .header'));

});
